module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('alert', {
    attrs: {
      "type": "info",
      "icon": "warning",
      "align": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('message.labelStartProgramOver')) + "\n    "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "pointer",
    attrs: {
      "slot": "action"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelClickHere'))
    },
    on: {
      "click": _vm.confirmRestart
    },
    slot: "action"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2630193d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResetAccount/ResetAccount.vue
// module id = 3641
// module chunks = 1